export default "__VITE_ASSET__BzwLp6$g__"